export type HealthInsightScoreBand = {
  label: string;
  range: string;
  color: string;
  bg: string;
  border: string;
  dot: string;
};

const excellent: Omit<HealthInsightScoreBand, "label" | "range"> = {
  color: "text-green-700 dark:text-green-400",
  bg: "bg-green-50 dark:bg-green-900/20",
  border: "border-green-200 dark:border-green-800",
  dot: "bg-green-500",
};

const good: Omit<HealthInsightScoreBand, "label" | "range"> = {
  color: "text-blue-700 dark:text-blue-400",
  bg: "bg-blue-50 dark:bg-blue-900/20",
  border: "border-blue-200 dark:border-blue-800",
  dot: "bg-blue-500",
};

const needsImprovement: Omit<HealthInsightScoreBand, "label" | "range"> = {
  color: "text-orange-700 dark:text-orange-400",
  bg: "bg-orange-50 dark:bg-orange-900/20",
  border: "border-orange-200 dark:border-orange-800",
  dot: "bg-orange-500",
};

const poor: Omit<HealthInsightScoreBand, "label" | "range"> = {
  color: "text-red-700 dark:text-red-400",
  bg: "bg-red-50 dark:bg-red-900/20",
  border: "border-red-200 dark:border-red-800",
  dot: "bg-red-500",
};

function band(
  label: string,
  range: string,
  style: Omit<HealthInsightScoreBand, "label" | "range">,
): HealthInsightScoreBand {
  return { label, range, ...style };
}

export const CARB_FIBER_SCORE_BANDS: HealthInsightScoreBand[] = [
  band("Excellent", "67 – 100", excellent),
  band("Good", "29 – 66", good),
  band("Needs Improvement", "1 – 28", needsImprovement),
  band("Poor", "0", poor),
];

export const SUGAR_LOAD_SCORE_BANDS: HealthInsightScoreBand[] = [
  band("Excellent", "51 – 100", excellent),
  band("Needs Improvement", "1 – 50", needsImprovement),
  band("Poor", "0", poor),
];

export const FAT_QUALITY_SCORE_BANDS: HealthInsightScoreBand[] = [
  band("Excellent", "38 – 100", excellent),
  band("Needs Improvement", "1 – 37", needsImprovement),
  band("Poor", "0", poor),
];

export const PROTEIN_FIBER_SCORE_BANDS: HealthInsightScoreBand[] = [
  band("Excellent", "61 – 100", excellent),
  band("Good", "21 – 60", good),
  band("Needs Improvement", "1 – 20", needsImprovement),
  band("Poor", "0", poor),
];

export const HEALTH_INSIGHT_SCORE_BANDS_BY_KEY = {
  carb_fiber_ratio_daily: CARB_FIBER_SCORE_BANDS,
  bad_fat_ratio_daily: FAT_QUALITY_SCORE_BANDS,
  sugar_ratio_daily: SUGAR_LOAD_SCORE_BANDS,
  protein_fiber_ratio_daily: PROTEIN_FIBER_SCORE_BANDS,
} as const;
